import React, { useState } from "react";
import { BootstrapModal } from "../../../BootstrapModal/Modal";
import styled from "styled-components";
import { CgClose } from "react-icons/cg";
import Button from "../../../Button/Button";
import {
  useFetchAllPropertyList,
  useUpdatePropertyLevel2,
} from "../../../../hooks/useContent";
import {
  RefreshTableLevelSecond,
  ContentUnitModal,
} from "../../../../shared/content-unit";
import { useRecoilState } from "recoil";
import {
  RowElement,
  RowLayoutStyle,
} from "../../../ContentUnit/Sliders/AddSlide";
import { InputField1 } from "../../../InputField1/InputField1";
import Spinner from "react-bootstrap/Spinner";
import Typography from "../../../Typography/Typography";
import { errorMessage } from "../../../../utils/message";
import { SimpleSelect1 } from "../../../SimpleSelect/SimpleSelect1";

function EditPropertyLevel2({ show, handleClose }) {
  const {
    mutateAsync: updateProperty,
    isLoading: reqLoading,
    isError: reqError,
  } = useUpdatePropertyLevel2();
  const [refreshEffect, setRefreshEffect] = useRecoilState(
    RefreshTableLevelSecond
  );
  const [updateState, setUpdateState] = useRecoilState(ContentUnitModal);

  // const [categoryId, setCategoryId] = useState(-1);

  // const { data, refetch, isLoading } = useFetchAllPropertyList();

  // const selectOptions = data?.data?.properties?.map((cat) => {
  //   return { value: cat.IdProperties, label: cat.TitleProperties };
  // });

  const [initialValues, setValueForm] = useState({
    title: updateState.updatePropertyLevel2.value.AmountFeatureValues
      ? updateState.updatePropertyLevel2.value?.AmountFeatureValues
      : "",
    en_title: updateState.updatePropertyLevel2.value.AmountFeatureValuesEnglish
      ? updateState.updatePropertyLevel2.value?.AmountFeatureValuesEnglish
      : "",
    ar_title: updateState.updatePropertyLevel2.value.AmountFeatureValuesLanguage
      ? updateState.updatePropertyLevel2.value?.AmountFeatureValuesLanguage
      : "",
  });

  const handleChange = (e) => {
    const { value, name } = e.target;
    setValueForm({ ...initialValues, [name]: value });
  };

  const validateForm = () => {
    if (initialValues.title.length < 1) {
      errorMessage("لطفا نام فارسی دسته بندی را وارد کنید");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      const queryData = {
        ...initialValues,
        feature_id: updateState.updatePropertyLevel2.value?.IdFeatureValues,
      };

      updateProperty(queryData).then((res) => {
        setRefreshEffect(!refreshEffect);
        handleClose();
      });
    }
  };

  // const handleChangeSelectMode = (e) => {
  //   const { value } = e;
  //   setCategoryId(value);
  // };

  return (
    <BootstrapModal
      show={show}
      handleClose={handleClose}
      modaltitle={"ویرایش ویژگی سطح 2"}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <UpdateCategoryStyle>
        {/* <SimpleSelect1
          label={"انتخاب دسته بندی"}
          onChange={handleChangeSelectMode}
          value={
            selectOptions?.length > 0
              ? selectOptions[0]?.label
              : "انتخاب دسته بندی"
          }
          res={selectOptions}
        /> */}
        <RowColumn>
          <InputField1
            type="text"
            name="title"
            label="نام فارسی"
            onChange={handleChange}
            value={initialValues?.title}
            placeholder="نام فارسی دسته بندی.."
            maxLenght="50"
          />

          <InputField1
            type="text"
            name="en_title"
            label="نام انگلیسی"
            onChange={handleChange}
            value={initialValues?.en_title}
            placeholder="نام انگلیسی دسته بندی..."
            maxLenght="50"
          />

          <InputField1
            type="text"
            name="ar_title"
            label="نام عربی"
            onChange={handleChange}
            value={initialValues?.ar_title}
            placeholder="نام دسته بندی عربی ..."
            maxLenght="50"
          />
        </RowColumn>
        <Button
          bgColor={"#4c78a9"}
          small={"100px"}
          className="m-r-1"
          onclick={(e) => {
            !reqLoading && handleSubmit();
          }}
          color="#fff"
        >
          {reqLoading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <Typography size={"15px"} primary={"#fff"}>
              ویرایش
            </Typography>
          )}
        </Button>
        <Button
          className={"mr-2"}
          style={{ marginRight: "10px" }}
          color={"#fff"}
          bgColor={"#f1416c"}
          small={"100px"}
          onclick={handleClose}
        >
          <Typography size={"15px"} primary={"#fff"}>
            انصراف
          </Typography>
        </Button>
      </UpdateCategoryStyle>
    </BootstrapModal>
  );
}

const UpdateCategoryStyle = styled.div`
  row-gap: 1rem;
`;

const RowColumn = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;

export default EditPropertyLevel2;
